import { Router } from '@angular/router';
import { HasPermissionService } from 'app/shared/haspermission/hasPermission.service';
import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GuardRutasGuard implements  CanActivate{
  constructor(
    private hasPermissionService: HasPermissionService,
    private router: Router
    ){}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    
    if(route.data.permiso){
      if (this.hasPermissionService.canAccess(route.data.permiso)){
        return true;
      }else{
        return this.router.navigate(['/login']).then(() => false);
      }
    }else{
      return this.router.navigate(['/login']).then(() => false);
    }
      
  }

  
}
